import { ScreenWrapper } from '@south-street-app/molecules';
import { useChatStore } from '@south-street-app/stores';

import { SupportConversationContent } from './SupportConversationContent';

const SupportChatScreen = () => {
  const supportConversation = useChatStore((state) => state.supportConversation);

  return (
    <ScreenWrapper>
      <SupportConversationContent conversation={supportConversation} />
    </ScreenWrapper>
  );
};

export { SupportChatScreen };
